<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_10",
      next: "P_12",
      topic: "Taller ¿Qué es crédito? / ¡Quiero saber qué es y para qué sirve un crédito!",
      reactivos: [
        {
          descripcion: "Tu amigo tiene buenas referencias y cuenta con capacidad de pago."
        },
        {
          descripcion: "Tu amigo es dueño de un negocio y algunas propiedades."
        },
        {
          descripcion: "Tu amigo sabe cómo obtener y utilizar un crédito."
        },
        {
          descripcion: "Tu amigo tiene trabajo y familia estables."
        },
        {
          descripcion: "Tu amigo tiene buenos amigos y conoces a su familia."
        }
      ],
      selected: [],
      respuesta: "none",
      response: 0,
      correcta: 0,
      sent: false,
      feedback: false,
      dialog: false
    };
  },
  methods: {
    sendResult() {
      if (this.respuesta == this.correcta) {
        this.response = 1;
      }
      this.sent = true;
      eventBus.$emit("send_result", this.response);
    },

  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    },
    checkResult() {
      return {
        done: this.response != "none",
        clear: this.response == "none"
      };
    }
  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') Estás en: {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B') PREGUNTA
            v-card-text.titulo24Reg
              | Juan se te acerca y te consulta, con la confianza de siempre. 
            v-card-text.parrafoDestacadoB.text-center  Marca tu respuesta.
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | ¿Cuál de estas razones le dirías que tome en cuenta para prestarle dinero a su amigo?  
              v-radio-group(v-model='respuesta')
                v-layout.ml-5(v-for='(reactivo, index) in reactivos', :key='index')
                  v-flex.iconos.text-xs-center.pt-3(xs1, align-center, align-content-center)
                    div(v-if='sent && (correcta == index || respuesta == index)')
                      v-icon(size='15px', color='green', v-if='sent && (correcta == index)') fas fa-check
                      v-icon(size='15px', color='red', v-if='sent && (correcta != index)') fas fa-times
                  v-flex.iconos.text-xs-right(xs1, align-content-center)
                    v-radio(hide-details, :value='index')
                  v-flex.label16tt_blue.text-xs-left.xs10.align-content-center
                    div(style="display:inline;" v-html="reactivo.descripcion").pr-5.parrafoDestacadoB
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false')
                  v-btn.btn(color='secondary', v-bind:class='responseIsNone', :disabled="respuesta=='none'", @click='sendResult()')
                    | Enviar
                div(v-if='sent')
                  v-btn.btn(color='accent', style='z-index:2', @click.prevent='dialog=true')
                    | Retroalimentación
                  v-dialog(v-model='dialog', persistent, max-width='930px', content-class="dialog_over")
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (respuesta==correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoOk.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Estás en el lugar indicado! 
                          .pt-1.pr-2(v-if='sent && (respuesta!=correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                          v-card.px-5.questionCard(justify-center, flat)
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==0)')
                              v-card-text.dialog_text
                                | ¡Qué buen consejo! Buenas referencias, y saber si cuenta con capacidad de pago son elementos esenciales que te permiten creer en esa persona que te solicita un préstamo. El historial de comportamiento con otros créditos es otro elemento que te ayudaría. 
                              v-card-text.dialog_text
                                | El banco pasa por un proceso similar y tiene esos requisitos para otorgar préstamos
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==1)')
                              v-card-text.dialog_text
                                | Es una alternativa válida, pero que cuente con bienes o trabajo no garantiza que tenga capacidad de pago, a menos que deje algunos de sus bienes en garantía (como es el caso del crédito hipotecario de liquidez) 
                              v-card-text.dialog_text
                                | Recuerda que cuando realizas un préstamo es importante asegurarte de que esa persona cuenta con un buen historial o referencias de que no ha tenido problemas con el pago de sus créditos. 
                              v-card-text.dialog_text
                                | El banco pasa por un proceso similar y tiene esos requisitos para otorgar préstamos. 
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==2)')
                              v-card-text.dialog_text
                                |  Es una opción viable, pero que sepa cómo obtener un crédito y cómo utilizarlo, no garantiza el cumplimiento del pago. 
                              v-card-text.dialog_text
                                | Cuando realizas un préstamo es importante asegurarte de que esa persona cuenta con un buen historial o referencias de que no ha tenido problemas con el pago de sus créditos. 
                              v-card-text.dialog_text
                                | El banco pasa por un proceso similar y tiene esos requisitos para otorgar préstamos. 
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==3)')
                              v-card-text.dialog_text
                                | La estabilidad del trabajo y familia de tu amigo te puede dar una idea de su capacidad de pago, pero no es garantía que la tenga o que vaya a cumplir con el pago. 
                              v-card-text.dialog_text
                                | Cuando realizas un préstamo es importante asegurarte de que esa persona cuenta con un buen historial o referencias de que no ha tenido problemas con el pago de sus créditos. 
                              v-card-text.dialog_text
                                | El banco pasa por un proceso similar y tiene esos requisitos para otorgar préstamos. 
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==4)')
                              v-card-text.dialog_text
                                | Conocer a sus familiares y amigos te puede ayudar a saber más sobre su estilo de vida, pero no son factores que te garanticen el cumplimiento de su pago. ç
                              v-card-text.dialog_text
                                | Cuando realizas un préstamo es importante asegurarte de que esa persona cuenta con un buen historial o referencias de que no ha tenido problemas con el pago de sus créditos.
                              v-card-text.dialog_text
                                | El banco pasa por un proceso similar y tiene esos requisitos para otorgar préstamos.  
                          v-btn.btn.dialog_btn.my-4(color='accent', @click.prevent="nextPage(next)")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>

